import React from "react";
import { Checkbox } from "@graffer-inc/console-design-kit";

type Props = {
  value: boolean;
  disabled?: boolean;
  onChange: () => void;
};

export const SurveyNotifyArrivalSetting: React.FC<Props> = ({
  value,
  disabled,
  onChange,
}) => {
  return (
    <div className="field">
      <Checkbox
        label={"新規回答到達メール通知設定"}
        description={
          "新規の回答が届いたら、アンケートを管理するグループの所属ユーザー全員に通知メールを送ります。"
        }
        options={[
          {
            name: "新規回答が届いたら通知する",
            value: "notifyArrival",
          },
        ]}
        values={value ? ["notifyArrival"] : []}
        onChange={onChange}
        disabled={disabled}
      />
    </div>
  );
};
